import React from 'react';
import { Button, Icon, IconNames, Image } from '@dotcom/crown-ui';
import classNames from 'classnames';
import { PhotoImageProps } from '../photo-drawer-types';
import styles from '../photo-drawer.module.scss';
import { useFeatureFlags } from '../../../../hooks/use-feature-flags';

export const PhotoImage = ({
  photo,
  isSelected,
  onSelect,
  isDeleting,
  onDelete,
}: PhotoImageProps): React.ReactElement => {
  const SelectedPhotoIcon = () => (
    <div className={styles['outer-circle']}>
      <div className={styles['inner-circle']}></div>
    </div>
  );

  const classes = classNames(styles['photo-container'], styles['photo-selectable']);
  const { IS_PHOTO_TRAY_DRAG_TO_CANVAS_ENABLED: isDragToCanvasEnabled } = useFeatureFlags();
  const [isLoaded, setIsLoaded] = React.useState(false);

  return (
    <div
      className={isDeleting ? classes : styles['photo-container']}
      onClick={onSelect.bind(null, photo)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect.bind(null, photo);
        }
      }}
      role="button"
      tabIndex={0}
      data-testid={`uploaded-photo-${photo.image_id}`}
    >
      {isSelected && <SelectedPhotoIcon />}
      <Image
        className={!isLoaded || (!isSelected && isDeleting) ? styles['photo-loading'] : undefined}
        onLoad={() => setIsLoaded(true)}
        src={photo.image_url}
        alt={'Uploaded by user'}
        onDragStart={
          isDragToCanvasEnabled
            ? (e) => {
                e.dataTransfer.setData('id', photo.photo_tray_image_id);
              }
            : undefined
        }
        id={photo.photo_tray_image_id}
        draggable={isDragToCanvasEnabled}
      />
      <Button
        size="icon-sm"
        variant="secondary"
        aria-label="Delete photo"
        data-testid={`delete-photo-${photo.image_id}`}
        onPointerDown={(e) => e.stopPropagation()}
        onClick={(e) => {
          e.stopPropagation();
          onDelete(photo, e);
        }}
        className={styles['photo-delete-quick-button']}
      >
        <Icon name={IconNames.MenuCloseBold} size="14" />
      </Button>
    </div>
  );
};
